import React, { useRef } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

// Components

import ModalAccessibilityWrapper from '@containers/common/ModalAccessibilityWrapper';

// ActionCreators

import { hideAllModals, hideModal, showModal } from '@actions/common/actionCreators';

// Utils

import { modalTools } from '@utils/tools/modalTools';

// Constants

import { commonModalConfig } from '@constants/common/modals/commonModalConfig';
import { lceModalConfig } from '@constants/lce/modals/lceModalConfig';
import { ssapModalConfig } from '@constants/ssap/modals/ssapModalConfig';
import { dashboardModalConfig } from '@constants/individualPortal/dashboard/modals/dashboardModalConfig';
import { ticketMgmtModalConfig } from '@constants/ticketMgmt/modals/ticketMgmtModalConfig';
import { entityModalConfig } from '@constants/entity/modals/entityModalConfig';


/**
*
* @param {Object} props - contains "modals" prop and "hideModal" action creator from Redux Store
* @returns {React.Component} - modal layout and the container what contains needed modal
*
*/
const ModalContainer = props => {

    const {
        actions: commonActions,
        modals = [],
        modals: {
            length: modalsQty
        }
    } = props;
    const modalBoundary = useRef();

    const modalBoundaryClassName = 'modal_boundary';

    const modalsList = Object.entries({
        common: commonModalConfig,
        dashboard: dashboardModalConfig,
        lce: lceModalConfig,
        ssap: ssapModalConfig,
        ticketMgmt: ticketMgmtModalConfig,
        entity : entityModalConfig
    }).map(([ containerName, modals ]) => ({
        containerName,
        modals
    }));

    const getModals = () => {

        return modals.map(modal => {

            const {
                modalType,
                zIndex,
                modalData
            } = modal;

            const {
                modalId = 'id-has-not-been-got',
                formName
            } = modalTools.getModalFromConfigsByModalType(modalsList, modalType);

            return (

                <div
                    key={ modalId }
                    className="gi-modal__layout"
                    style={{
                        zIndex
                    }}
                >

                    <div
                        className={`${modalBoundaryClassName} gi-modal__content ${modalData && modalData.className}`}
                        tabIndex='-1'
                        id='modal-content' // TODO Has to be refactored. Not unique!
                        role='dialog'
                        ref={ modalBoundary }
                        aria-describedby={ modalId }
                        data-modaltype={modalType}
                    >
                        <ModalAccessibilityWrapper
                            { ...{
                                commonActions,
                                formName,
                                modalBoundary,
                                modalBoundaryClassName,
                                modal,
                                modalType,
                                modalsList,
                                modalsQty
                            } }
                        />
                    </div>
                </div>
            );
        });
    };

    return modalsQty > 0 ? getModals() : null;
};

const mapStateToProps = state => ({
    modals: state.common.modals
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({
        hideAllModals,
        hideModal,
        showModal
    }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(ModalContainer);
